import { GetReportFilterReq } from "../interfaces/event.interface";
import { API } from "./api";

export const getMapDataService = async (daysAgo: number, packageName: string, eventType: string): Promise<any>=>{
    try {
        const res = await API.get(`/v1/event/map?days-ago=${daysAgo}&package-name=${packageName}&event-type=${eventType}`, );
        return res.data;
    } catch (error) {
        throw error
    }
}

export const getRiskPerDayService = async (daysAgo: number, packageName: string, eventType: string ): Promise<any>=>{
    try {
        const res = await API.get(`/v1/event/risk-per-day?days-ago=${daysAgo}&package-name=${packageName}&event-type=${eventType}`, );
        return res.data;
    } catch (error) {
        throw error
    }
}

export const getEventCountPerEventTypeService = async (daysAgo: number, packageName: string ): Promise<any>=>{
    try {
        const res = await API.get(`/v1/event/event-count-per-event-type?days-ago=${daysAgo}&package-name=${packageName}`, );
        return res.data;
    } catch (error) {
        throw error
    }
}

export const getTopRiskDeviceService = async (daysAgo: number, packageName: string, eventType: string): Promise<any>=>{
    try {
        const res = await API.get(`/v1/event/top-risk-device?days-ago=${daysAgo}&package-name=${packageName}&event-type=${eventType}`, );
        return res.data;
    } catch (error) {
        throw error
    }
}

export const getTopRiskDeviceModelService = async (daysAgo: number, packageName: string, eventType: string): Promise<any>=>{
    try {
        const res = await API.get(`/v1/event/top-risk-device-model?days-ago=${daysAgo}&package-name=${packageName}&event-type=${eventType}`, );
        return res.data;
    } catch (error) {
        throw error
    }
}

export const getTopRiskAppVersionService = async (daysAgo: number, packageName: string, eventType: string ): Promise<any>=>{
    try {
        const res = await API.get(`/v1/event/top-risk-app-version?days-ago=${daysAgo}&package-name=${packageName}&event-type=${eventType}`, );
        return res.data;
    } catch (error) {
        throw error
    }
}

export const getDistinctValuesService = async (filedName: string): Promise<any>=>{
    try {
        const res = await API.get(`/v1/event/distinct-value?field_name=${filedName}`, );
        return res.data;
    } catch (error) {
        throw error
    }
}

export const getReportService = async (data: GetReportFilterReq): Promise<any>=>{
    try {
        const res = await API.post(`/v1/event/report`, data);
        return res.data;
    } catch (error) {
        throw error
    }
}